import { createFileRoute } from '@tanstack/react-router';
import { Swords } from 'lucide-react';
import { CompetitorsPage } from './index';

export const Route = createFileRoute(
  '/_authenticated/_layout/competitors/$competitorId',
)({
  component: CompetitorsPage,
  staticData: {
    title: 'Competitors',
    icon: Swords,
  },
});
